import { HotelForm as Form } from 'hotel/HotelForm';
import { Field } from 'react-final-form';

import { Button } from 'components/Button';
import TextArea from 'components/Inputs/FormInputs/TextArea';
import { CreateRosterRequestRemarkInput } from 'generated/graphql';

export type RequestRemarksFormProps = {
  onSubmit: (
    values: CreateRosterRequestRemarkInput,
    form: { reset: () => void },
  ) => void;
};

const RequestRemarksForm = ({ onSubmit }: RequestRemarksFormProps) => {
  return (
    <Form
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-6">
            <div className="col-span-6 mb-5">
              <Field
                labelText="Remarks"
                name="note"
                component={TextArea}
                rows={5}
              />
            </div>
            <div className="col-span-6">
              <Button type="submit">Submit</Button>
            </div>
          </div>
        </form>
      )}
    />
  );
};

export default RequestRemarksForm;
